const BASE_URL_SERVER = `${process.env.VUE_APP_SERVER_URL}`;

import axios from "axios";

const API_ENDPOINT = {
    UPLOAD_FILE_API: '/api/upload',
}

class UploadService {
    uploadFile  = (data) => {
        const userLocal = localStorage.getItem('user');
        const user = JSON.parse(userLocal);

        const config = {
            headers: {
                'content-type': 'multipart/form-data',
                'Authorization': `Bearer ${user.jwt}`
            }
        };
        return axios.post(BASE_URL_SERVER + API_ENDPOINT.UPLOAD_FILE_API, data, config);
    };
}

const uploadService = new UploadService();
export default uploadService;